/* "Complete your order" step: when the shopper taps Checkout, a full-screen step (phones) / panel (desktop) offers
   add-ons with +/- on every row and a live total: "finish it better" tools (first the easel that fits the kit size
   in the cart), then holiday picks (every variant of one product). Tapping a photo opens its pictures (mockups).
   "Continue to checkout" adds what was picked (line property _upsell: checkout-popup, so the Shopify Flow tag keeps
   working) and opens checkout. Replaces the popup in assets/wp-upsell.js.
   Shown when: at least 1 kit in the cart, no custom kit, something to offer, not shown yet this visit (sessionStorage wpcs-shown).
   Mode: Theme settings > WP Cart > Complete your order step: off | test (only after ?step=test; ?step=off to leave)
   | ab (half of the shoppers, kept per browser in localStorage wpcs-ab; the half is written to the cart attribute
   _upsell_ab so orders can be compared) | on.
   Data: wpCartConfig.step (snippets/wp-cart.liquid). Variant rows: [id, title, price, compare at, image, available, big image]. */
(() => {
  const C = window.wpCartConfig;
  if (!C || !C.step || C.step.mode === 'off') return;
  const store = (fn) => { try { return fn(); } catch (e) { return null; } };
  let test = false;
  store(() => {
    const q = new URLSearchParams(location.search).get('step');
    if (q === 'test') sessionStorage.setItem('wpcs-test', '1');
    if (q === 'off') sessionStorage.removeItem('wpcs-test');
    test = sessionStorage.getItem('wpcs-test') === '1';
  });
  const mode = C.step.mode;
  if (mode === 'test' && !test) return;
  let bucket = 'step';
  if (mode === 'ab' && !test) {
    bucket = store(() => localStorage.getItem('wpcs-ab'));
    if (bucket !== 'step' && bucket !== 'direct') {
      bucket = Math.random() < 0.5 ? 'step' : 'direct';
      store(() => localStorage.setItem('wpcs-ab', bucket));
    }
  }
  const nativeFetch = () => (window.wpCart && window.wpCart.fetch) || fetch;
  const post = (url, body, keepalive) => nativeFetch()(url, { method: 'POST', keepalive: !!keepalive, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });

  // 50/50: write the half to the cart once, so it reaches the order (both halves, also those who never see the step)
  if (mode === 'ab' && !test) {
    let sent = false;
    document.addEventListener('wp:cart-rendered', (e) => {
      const cart = e.detail;
      if (sent || !cart || !cart.items || !cart.items.length || (cart.attributes && cart.attributes._upsell_ab === bucket)) return;
      sent = true;
      post('/cart/update.js', { attributes: { _upsell_ab: bucket } }, true).catch(() => { sent = false; });
    });
  }
  if (bucket === 'direct') return;

  const money = (c) => new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.currency || 'USD' }).format((c || 0) / 100);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (u, w) => `${String(u).split('?')[0]}?width=${w}`;
  const kaching = (it) => { try { return JSON.parse(it.properties && it.properties.__kaching_bundles); } catch (e) { return null; } };
  const isCustom = (it) => /custom|personali/i.test(it.handle || '');
  // a kit (PBN or diamond), not a tool inside a bundle
  const isKit = (it) => { const k = kaching(it); return C.kitTypes.includes(it.product_type) && !(k && !k.main && !k.checkboxUpsell); };
  const eligible = (cart) => !!(cart && cart.items && cart.items.length && !cart.items.some(isCustom) && cart.items.some(isKit));
  const suppressed = () => !test && store(() => sessionStorage.getItem('wpcs-shown') === '1');

  // a section's "alts" (e.g. ballpark minis, then nature minis) replace it: the first one whose collections (alt.c)
  // hold a product of the cart wins. Product ids come from sections/wp-step-ids.liquid (250 a page), kept for the
  // visit in sessionStorage
  const idSets = new Map(); // collection handle -> Promise<Set> (.data once loaded)
  const loadIds = (h) => {
    if (!idSets.has(h)) {
      const key = `wpcs-ids-${h}`;
      const cached = store(() => JSON.parse(sessionStorage.getItem(key) || 'null'));
      const page = (n) => fetch(`/collections/${encodeURIComponent(h)}?section_id=wp-step-ids&page=${n}`, { headers: { Accept: 'text/html' } })
        .then((r) => r.text()).then((t) => JSON.parse(/data-wpcs-ids>([\s\S]*?)<\/script>/.exec(t)[1]));
      const all = async () => {
        let ids = [];
        for (let n = 1; n <= 8; n++) { const got = await page(n); ids = ids.concat(got); if (got.length < 250) break; }
        store(() => sessionStorage.setItem(key, JSON.stringify(ids)));
        return ids;
      };
      const p = cached ? Promise.resolve(cached) : all();
      const q = p.then((ids) => { q.data = new Set(ids); return q.data; }, () => { q.data = new Set(); return q.data; });
      idSets.set(h, q);
    }
    return idSets.get(h);
  };
  const altLoads = () => (C.step.sections || []).flatMap((s) => (s.alts || []).flatMap((a) => a.c)).map(loadIds);
  const holds = (cart, a) => a.c.some((h) => { const q = idSets.get(h); return q && q.data && cart.items.some((it) => q.data.has(it.product_id)); });
  // the large easel when any kit in the cart has a side of 18" or more (18"x24"), else the small one
  const bigKit = (cart) => cart.items.filter(isKit).some((it) => (it.options_with_values || []).some((o) => {
    const m = /(\d+(?:\.\d+)?)\s*"?\s*x\s*(\d+(?:\.\d+)?)\s*"/i.exec(o.value || '');
    return m && Math.max(+m[1], +m[2]) >= 18;
  }));

  // ----- the offer -----
  const buildOffer = (cart) => {
    const inCart = new Set(cart.items.map((it) => it.handle));
    const big = bigKit(cart);
    const sections = [];
    (C.step.sections || []).forEach((sec0, si) => {
      const a = (sec0.alts || []).find((x) => holds(cart, x));
      const sec = a ? { ...sec0, ...a } : sec0;
      const rows = [];
      (sec.products || []).forEach((p) => {
        if (sec.kind === 'finish' && inCart.has(p.h)) return; // already has it
        let vs = p.v.filter((v) => v[5]);
        if (p.easel) vs = vs.filter((v) => (big ? /large/i : /small/i).test(v[1])).concat(vs).slice(0, 1);
        const names = p.v.map((v) => v[1]);
        (sec.kind === 'finish' ? vs.slice(0, 1) : vs).forEach((v) => {
          // photos: the product photos named after this variant (mockups) first, then the variant photo,
          // then photos not named after any variant (e.g. what is in the kit)
          const all = p.m || [];
          const base = (u) => String(u || '').split('?')[0];
          const own = sec.kind === 'finish' ? [] : all.filter(([u, alt]) => alt.includes(v[1]) && base(u) !== base(v[6]));
          const rest = sec.kind === 'finish' || /set of/i.test(v[1]) ? all : all.filter(([, alt]) => !names.some((n) => alt.includes(n)));
          const urls = [...new Set([...own.map((x) => x[0]), v[6], ...rest.map((x) => x[0])].filter(Boolean))];
          rows.push({
            key: `${si}:${v[0]}`, id: v[0], price: v[2], compare: v[3] > v[2] ? v[3] : 0, max: 9,
            title: sec.kind === 'finish' ? (p.easel ? `${p.t} · ${v[1].replace(/\s*\(.*\)/, '')}` : p.t.split(':')[0]) : v[1], image: v[4] || p.i, photos: urls, set: /set of/i.test(v[1]),
          });
        });
      });
      if (rows.length) sections.push({ title: sec.title, sub: sec.sub, rows });
    });
    return sections.length ? { sections } : null;
  };

  // ----- the step -----
  let root = null, current = null, qty = new Map(), busy = false;
  const build = () => {
    root = document.createElement('div');
    root.className = 'wpcs';
    root.innerHTML = `
      <div class="wpcs__dim" data-wpcs-back></div>
      <div class="wpcs__panel" role="dialog" aria-modal="true" aria-labelledby="wpcs-title" tabindex="-1">
        <div class="wpcs__top">
          <button type="button" class="wpcs__back" data-wpcs-back aria-label="Back to cart">&#8592;</button>
          <p class="wpcs__title" id="wpcs-title">Complete your order</p>
        </div>
        <div class="wpcs__body" data-wpcs-body></div>
        <div class="wpcs__foot">
          <p class="wpcs__sum"><span>Total <span class="wpcs__saved" data-wpcs-saved></span></span><b data-wpcs-total></b></p>
          <button type="button" class="wpcs__go" data-wpcs-go></button>
        </div>
        <div class="wpcs__zoom" data-wpcs-zoom hidden role="dialog" aria-label="Photos">
          <button type="button" class="wpcs__zx" data-wpcs-zclose aria-label="Close photos">&times;</button>
          <div class="wpcs__strip" data-wpcs-strip></div>
          <button type="button" class="wpcs__za wpcs__za--prev" data-wpcs-step="-1" aria-label="Previous photo">&#8249;</button>
          <button type="button" class="wpcs__za wpcs__za--next" data-wpcs-step="1" aria-label="Next photo">&#8250;</button>
          <p class="wpcs__zcap" data-wpcs-zcap></p>
        </div>
      </div>`;
    document.body.appendChild(root);
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-wpcs-zclose]')) return zoom(null);
      const st = e.target.closest('[data-wpcs-step]');
      if (st) { const strip = root.querySelector('[data-wpcs-strip]'); strip.scrollBy({ left: strip.clientWidth * Number(st.dataset.wpcsStep), behavior: 'smooth' }); return; }
      if (e.target.closest('[data-wpcs-back]')) return close();
      if (e.target.closest('[data-wpcs-go]')) return finish();
      const z = e.target.closest('[data-wpcs-zoom-key]');
      if (z) return zoom(rowByKey(z.dataset.wpcsZoomKey));
      const b = e.target.closest('[data-wpcs-q]');
      if (b) {
        const row = rowByKey(b.dataset.key);
        if (!row) return;
        qty.set(row.key, Math.min(row.max, Math.max(0, (qty.get(row.key) || 0) + Number(b.dataset.wpcsQ))));
        paint();
      }
    });
    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!root.querySelector('[data-wpcs-zoom]').hidden) zoom(null); else close();
    });
    const strip = root.querySelector('[data-wpcs-strip]');
    strip.addEventListener('scroll', () => {
      const n = strip.children.length, i = Math.round(strip.scrollLeft / Math.max(strip.clientWidth, 1));
      root.querySelector('[data-wpcs-zcap]').dataset.n = n > 1 ? `${i + 1} / ${n}` : '';
    }, { passive: true });
  };
  const rows = () => current.offer.sections.flatMap((s) => s.rows);
  const rowByKey = (k) => rows().find((r) => r.key === k);
  const picks = () => rows().filter((r) => qty.get(r.key) > 0).map((r) => ({ ...r, qty: qty.get(r.key) }));

  // photos of one row, full width, swipe sideways
  let zoomFrom = null;
  const zoom = (row) => {
    const box = root.querySelector('[data-wpcs-zoom]');
    if (!row) {
      box.hidden = true;
      if (zoomFrom) zoomFrom.focus();
      return;
    }
    zoomFrom = document.activeElement;
    const strip = box.querySelector('[data-wpcs-strip]');
    strip.innerHTML = row.photos.map((u) => `<img src="${esc(sized(u, 900))}" alt="${esc(row.title)}" width="900" height="900">`).join('');
    strip.scrollLeft = 0;
    const cap = box.querySelector('[data-wpcs-zcap]');
    cap.textContent = row.title;
    cap.dataset.n = row.photos.length > 1 ? `1 / ${row.photos.length}` : '';
    box.querySelectorAll('[data-wpcs-step]').forEach((b) => { b.hidden = row.photos.length < 2; });
    box.hidden = false;
    box.querySelector('[data-wpcs-zclose]').focus();
  };

  const paint = () => {
    const { cart, offer } = current;
    const lines = cart.items.filter((it) => !(kaching(it) && !kaching(it).main));
    const head = lines[0];
    const order = `<div class="wpcs__order">
        ${head && head.image ? `<img src="${esc(sized(head.image, 120))}" alt="" width="52" height="52">` : ''}
        <div class="wpcs__ot"><b>${esc(head ? head.product_title.split('|')[0].trim() : '')}</b>${lines.length > 1 ? `<span>+ ${lines.length - 1} more item${lines.length > 2 ? 's' : ''}</span>` : `<span>${esc(head && head.variant_title && head.variant_title !== 'Default Title' ? head.variant_title : '')}</span>`}</div>
        <span class="wpcs__op">${money(cart.total_price)}</span>
      </div>`;
    const body = offer.sections.map((s) => `<section class="wpcs__sec">
        <p class="wpcs__h">${esc(s.title)}</p>
        ${s.sub ? `<p class="wpcs__sub">${esc(s.sub)}</p>` : ''}
        ${s.rows.map((r) => {
          const q = qty.get(r.key) || 0;
          const save = r.set && r.compare ? `<span class="wpcs__tag">Save ${money(r.compare - r.price)}</span>` : '';
          return `<div class="wpcs__row">
            <button type="button" class="wpcs__img" data-wpcs-zoom-key="${esc(r.key)}" aria-label="See photos of ${esc(r.title)}">${r.image ? `<img src="${esc(r.image)}" alt="" width="58" height="58" loading="eager">` : ''}</button>
            <span class="wpcs__rt"><b>${esc(r.title)}${save}</b><span class="wpcs__price"><b>${money(r.price)}</b>${r.compare ? `<s>${money(r.compare)}</s>` : ''}</span></span>
            <span class="wpcs__qty${q ? ' is-on' : ''}">
              <button type="button" data-wpcs-q="-1" data-key="${esc(r.key)}" aria-label="Remove one ${esc(r.title)}"${q ? '' : ' disabled'}>&minus;</button>
              <output aria-live="polite">${q}</output>
              <button type="button" data-wpcs-q="1" data-key="${esc(r.key)}" aria-label="Add one ${esc(r.title)}"${q >= r.max ? ' disabled' : ''}>+</button>
            </span>
          </div>`;
        }).join('')}
      </section>`).join('');
    const el = root.querySelector('[data-wpcs-body]');
    const top = el.scrollTop;
    el.innerHTML = order + body;
    el.scrollTop = top;
    const chosen = picks();
    const added = chosen.reduce((s, r) => s + r.price * r.qty, 0);
    const saved = chosen.reduce((s, r) => s + (r.compare ? (r.compare - r.price) * r.qty : 0), 0);
    const total = cart.total_price + added;
    root.querySelector('[data-wpcs-total]').textContent = money(total);
    root.querySelector('[data-wpcs-saved]').textContent = saved > 0 ? `· you save ${money(saved)}` : '';
    root.querySelector('[data-wpcs-go]').textContent = `Continue to checkout · ${money(total)}`;
  };

  const show = (cart, offer) => {
    if (!root) build();
    current = { cart, offer };
    qty = new Map();
    busy = false;
    root.querySelector('[data-wpcs-go]').disabled = false;
    root.querySelector('[data-wpcs-zoom]').hidden = true;
    paint();
    root.classList.add('is-open');
    document.documentElement.classList.add('wpcs-open');
    setTimeout(() => root.querySelector('.wpcs__panel').focus(), 30);
    store(() => sessionStorage.setItem('wpcs-shown', '1'));
    post('/cart/update.js', { attributes: { _upsell: 'shown' } }, true).catch(() => {});
  };
  const close = () => {
    if (!root || busy) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('wpcs-open');
  };

  const go = () => { location.href = C.checkoutUrl || '/checkout'; };
  const finish = async () => {
    if (busy) return;
    const chosen = picks();
    if (!chosen.length) { go(); return; }
    busy = true;
    const btn = root.querySelector('[data-wpcs-go]');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await post('/cart/add.js', { items: chosen.map((r) => ({ id: r.id, quantity: r.qty, properties: { _upsell: 'checkout-popup' } })) });
    } catch (e) { /* checkout anyway with what the cart has */ }
    go();
  };

  // ----- before the click: stylesheet and pictures, so the step opens complete -----
  let cssLoaded = false;
  const loadCss = () => {
    if (cssLoaded || !C.step.css) return;
    cssLoaded = true;
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = C.step.css;
    document.head.appendChild(l);
  };
  const preloaded = new Set();
  const prepare = (cart) => {
    if (!eligible(cart) || suppressed()) return;
    (window.requestIdleCallback || ((f) => setTimeout(f, 300)))(() => {
      loadCss();
      altLoads();
      const urls = (C.step.sections || []).flatMap((s) => [...(s.products || []), ...(s.alts || []).flatMap((a) => a.products)]).flatMap((p) => [p.i, ...p.v.map((v) => v[4])]);
      if (cart.items[0] && cart.items[0].image) urls.push(sized(cart.items[0].image, 120));
      urls.filter((u) => u && !preloaded.has(u)).forEach((u) => { preloaded.add(u); new Image().src = u; });
    });
  };
  document.addEventListener('wp:cart-rendered', (e) => prepare(e.detail));

  // ----- the cart we decide on: the drawer's last render, re-read when something changed it since (e.g. the cart page) -----
  let fresh = null, dirty = false;
  document.addEventListener('wp:cart-rendered', (e) => { fresh = e.detail; dirty = false; });
  const isCartWrite = (url, method) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url)) && String(method || 'GET').toUpperCase() === 'POST';
  const pf = window.fetch;
  window.fetch = function (input, init) {
    if (isCartWrite(typeof input === 'string' ? input : (input && input.url) || '', (init && init.method) || (input && input.method))) dirty = true;
    return pf.apply(this, arguments);
  };
  const px = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) { if (isCartWrite(url, method)) dirty = true; return px.apply(this, arguments); };
  const currentCart = async () => {
    const known = fresh || (window.wpCart && window.wpCart.getCart && window.wpCart.getCart());
    if (known && !dirty) return known;
    const f = (window.wpCart && window.wpCart.fetch) || pf;
    return f('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  };
  const within = (promise, ms) => Promise.race([promise.then((v) => ({ v }), () => null), new Promise((r) => setTimeout(() => r(null), ms))]);

  // ----- intercept Checkout (drawer button and cart page button; express buttons are left alone) -----
  let waiting = false;
  window.addEventListener('click', (e) => {
    const btn = e.target.closest('.wpc__checkout, #checkout, button[name="checkout"], input[name="checkout"]');
    if (!btn || e.metaKey || e.ctrlKey || waiting) return;
    if (root && root.contains(btn)) return;
    if (suppressed()) return;
    const known = fresh || (window.wpCart && window.wpCart.getCart && window.wpCart.getCart());
    if (known && !dirty && (!eligible(known) || !buildOffer(known))) return; // nothing to offer: normal checkout, no delay
    e.preventDefault();
    e.stopImmediatePropagation();
    waiting = true;
    btn.setAttribute('aria-busy', 'true');
    (async () => {
      const [got] = await Promise.all([within(currentCart(), 400), within(Promise.all(altLoads()), 400)]);
      const cart = got && got.v;
      const offer = eligible(cart) ? buildOffer(cart) : null;
      if (!offer) return go();
      loadCss();
      show(cart, offer);
    })().catch(go).finally(() => { waiting = false; btn.removeAttribute('aria-busy'); });
  }, true);

  // back from checkout: the browser may restore this page as it was (step open, button on "Adding…")
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    waiting = false;
    busy = false;
    dirty = true;
    document.documentElement.classList.remove('wpcs-open');
    if (root) {
      root.classList.remove('is-open');
      root.querySelector('[data-wpcs-go]').disabled = false;
    }
  });

  // the cart page has no drawer render before the click: prepare as soon as the cart is known
  const warm = () => { const c = window.wpCart && window.wpCart.getCart && window.wpCart.getCart(); if (c) prepare(c); };
  window.addEventListener('load', () => setTimeout(warm, 800));
  window.wpStep = { bucket, test, buildOffer };
})();
